import { render } from "./AdminInvites.vue?vue&type=template&id=b2899de6"
import script from "./AdminInvites.vue?vue&type=script&lang=js"
export * from "./AdminInvites.vue?vue&type=script&lang=js"

import "./AdminInvites.vue?vue&type=style&index=0&id=b2899de6&lang=scss"

import exportComponent from "/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__